function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "product_placemat");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.969 14.669h-2.663v-6.657h11.982v6.657h-7.988c0-0.8 0.533-1.331 1.331-1.331h5.325v-3.994h-9.318v3.994c0.798 0 1.331 0.532 1.331 1.331zM29.288 17.331h-7.988c0 0.8 0.533 1.331 1.331 1.331h5.325v3.994h-9.318v-3.994c0.8 0 1.331-0.532 1.331-1.331h-2.663v6.657h11.982zM14.644 17.331h-7.988c0 0.8 0.533 1.331 1.332 1.331h5.324v3.994h-9.318v-3.994c0.8 0 1.331-0.532 1.331-1.331h-2.663v6.657h11.982zM3.994 13.338v-3.994h9.318v3.994h-5.324c-0.8 0-1.332 0.532-1.332 1.331h7.988v-6.657h-11.982v6.657h2.663c0-0.799-0.533-1.331-1.331-1.331zM31.95 5.35v21.3h-31.95v-21.3zM30.619 6.681h-29.288v18.638h29.288z"
});

var SvgProductPlacemat = function SvgProductPlacemat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductPlacemat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_placemat.2313a5ab.svg";
export { ForwardRef as ReactComponent };